
import TitleBox from '@/components/CSS/TitleBox'
import { mapGetters } from 'vuex'

export default {
	components: {
		TitleBox
	},
	data() {
		return {
			realNameModelState: false
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo'
		}),
		cards() {
			return [
				{
					img: 'https://oss.pzds.com/pc-ssr-im/icon-realname.png',
					title: '实名认证',
					desc: '买家认证',
					authed: this.userinfo.isRealName
				},
				{
					img: 'https://oss.pzds.com/pc-ssr-im/icon-realperson.png',
					title: '实人认证',
					desc: '买家认证',
					authed: this.userinfo.isFaceCertified
				}
			]
		}
	},
	methods: {
		realNameModelSuccessCb() {
			// this.realNameModelState = false
			// this.$store.dispatch('user/UserGetInfo')
		},
		handleAuth(index, item) {
			if (item.authed) return
			if (index === 0) this.showRealNameModel()
			if (index === 1) this.routerCheck('realPerson')
		},
		showRealNameModel() {
			this.realNameModelState = true
			this.$store.dispatch('user/UserGetInfo')
		},
		routerCheck(name) {
			// 原实名认证
			// if (name === 'faceRecognition' && !this.userinfo.isRealName) return this.$message.warning('请先完成实名信息认证')
			// if (this.userinfo.isIndemnityWaiting) return this.$message.warning('请先等待包赔认证结束后再认证')
			// this.$router.push(name)
			// 现 身份证+人脸认证
			if (name === 'faceRecognition' && !this.userinfo.isRealName) return this.$message.warning('请先完成实人信息认证')
			if (this.userinfo.isIndemnityWaiting) return this.$message.warning('请先等待包赔认证结束后再认证')
			this.$router.push(name)
		},
		async doPageTracking() {
			const data = {
				action: {
					pageEnName: 'certification',
					pageZhName: '实名认证'
				}
			}
			const res = await this.$api.pageTracking(data)
			console.log(res)
		}
	},
	mounted() {
		this.$store.dispatch('user/UserGetInfo')
		// this.$store.dispatch("app/AppGetOssAuth");
		this.doPageTracking()
	}
}
